function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { extendTheme as extendChakraTheme } from "@chakra-ui/react";
import { ThemedSkeleton } from "../feedback";
import { ThemedMenu, ThemedModal, ThemedPopover, ThemedTooltip, ThemedDrawer } from "../overlay";
import { ThemedInput, ThemedNumberInput, ThemedButton, ThemedCloseButton, ThemedCheckbox, ThemedRadio, ThemedSelect, ThemedSwitch, ThemedTextarea, ThemedFormControl, ThemedPinInput, ThemedFormError, ThemedSlider } from "../form";
import { ThemedAccordion, ThemedTabs } from "../disclosure";
import { ThemedAvatar, ThemedIcon } from "../medias";
import { ThemedLink } from "../navigation";
import { ThemedHeading } from "../typography";
import { ThemedText } from "../typography";
import { ThemedContainer } from "../layout";
import { ThemedTable, ThemedList, ThemedLabel } from "../data-display";
import { ThemedProgress } from "../feedback";
import { tokens, createChakraTokens } from "@tempo/theme";
import { compatibilityTokens } from "./legacy";
const theme = _object_spread_props(_object_spread({}, createChakraTokens(compatibilityTokens)), {
    styles: {
        global: {
            body: {
                fontFamily: 'body',
                color: 'text.neutral.primary.default',
                bg: 'background.neutral.primary.default',
                lineHeight: 'base',
                fontSize: '16px'
            },
            '*::placeholder': {
                color: 'neutral.80',
                _dark: {
                    color: 'neutral.100'
                }
            },
            '*, *::before, &::after': {
                borderColor: 'divider.neutral.primary.default',
                wordWrap: 'break-word'
            },
            ':focus-visible': {
                outlineColor: 'border.accent.primary.default'
            }
        }
    },
    config: {
        cssVarPrefix: 'tempo'
    },
    components: {
        Accordion: ThemedAccordion,
        Button: ThemedButton,
        CloseButton: ThemedCloseButton,
        Popover: ThemedPopover,
        Input: ThemedInput,
        Icon: ThemedIcon,
        Modal: ThemedModal,
        Radio: ThemedRadio,
        Checkbox: ThemedCheckbox,
        Select: ThemedSelect,
        Switch: ThemedSwitch,
        NumberInput: ThemedNumberInput,
        Textarea: ThemedTextarea,
        FormControl: ThemedFormControl,
        FormError: ThemedFormError,
        Menu: ThemedMenu,
        Tooltip: ThemedTooltip,
        Drawer: ThemedDrawer,
        Link: ThemedLink,
        Container: ThemedContainer,
        Heading: ThemedHeading,
        Text: ThemedText,
        Table: ThemedTable,
        Progress: ThemedProgress,
        List: ThemedList,
        Skeleton: ThemedSkeleton,
        PinInput: ThemedPinInput,
        Label: ThemedLabel,
        Avatar: ThemedAvatar,
        Slider: ThemedSlider,
        Tabs: ThemedTabs
    }
});
const extendTheme = (...extensions)=>{
    const extendedTheme = extendChakraTheme(theme, ...extensions);
    delete extendedTheme.colors.yellow;
    delete extendedTheme.colors.blue;
    delete extendedTheme.colors.cyan;
    delete extendedTheme.colors.pink;
    return extendedTheme;
};
export { theme, extendTheme };
// For the demo
export const corePalette = _object_spread({}, tokens.colors);
export * from "./app-extensions/zen";

//# sourceMappingURL=index.js.map